import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ManagersBusinessDivisionsIndexRequestType,
  ManagersBusinessDivisionsIndexResponseType,
} from "~/domains";

type RequestDataType = {
  params?: ManagersBusinessDivisionsIndexRequestType;
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ManagersBusinessDivisionsIndexResponseType> => {
  const response =
    await new ApiClient().get<ManagersBusinessDivisionsIndexResponseType>(
      "/api/managers/business_divisions",
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ManagersBusinessDivisionsIndexRequestType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisManagersBusinessDivisionsIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ManagersBusinessDivisionsIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisManagersBusinessDivisionsIndex", params],
    ({ pageParam }) => {
      return request({ params, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
